"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomInt = void 0;
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
/**
 * This function returns a random integer between the specified values, [min, max);
 */
function getRandomInt(min, max) {
    (0, tiny_invariant_1.default)(Number.isInteger(min), "min must be an integer");
    (0, tiny_invariant_1.default)(Number.isInteger(max), "max must be an integer");
    return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}
exports.getRandomInt = getRandomInt;
